import React, { useState } from "react";

const CoverageDetails = () => {

    const [filter, setFilter] = useState("Brands")
    
  return (
    <div>
      <div className="coverage-details" id="coverage" >
        <div className="coverage-details-main">
          <div className="coverage-details-heading">RepairBuddy Services Coverage Details</div>

          <div className="coverage-details-filters">
            {/* <div className={filter === "Localities" ? "coverage-details-filters-active" :""} onClick={()=>setFilter("Localities")}>Localities</div> */}
            <div className={filter === "Brands" ? "coverage-details-filters-active" :""} onClick={()=>setFilter("Brands")}>Brands</div>
            <div className={filter === "Cities" ? "coverage-details-filters-active" :""} onClick={()=>setFilter("Cities")}>Cities</div>
            
          </div>


          <div className="coverage-details-content">

{
    filter === "Localities"?


            <div className="coverage-details-locations">

                <div>Dwarka, Delhi</div>
                <div>GK (Greater Kailash), Delhi</div>
                <div>Hauz Khas, Delhi</div>
                <div>Janakpuri, Delhi</div>
                <div>Karol Bagh, Delhi</div>
                <div>Lajpat Nagar, Delhi</div>
                <div>Laxmi Nagar, Delhi</div>
                <div>Model Town, Delhi</div>
                <div>Nehru Place, Delhi</div>
                <div>Okhla, Delhi</div>
                <div>Paschim Vihar, Delhi</div>
                <div>Patel Nagar, Delhi</div>
                <div>Pitampura, Delhi</div>
                <div>Punjabi Bagh, Delhi</div>
                <div>R K Puram, Delhi</div>
                <div>Rajouri Garden, Delhi</div>
                <div>Rohini, Delhi</div>
                <div>Saket, Delhi</div>
                <div>South Ex, Delhi</div>
                <div>Uttam Nagar, Delhi</div>
                <div>Vasant Kunj, Delhi</div>
                <div>Vikaspuri, Delhi</div>
                <div>Ghaziabad </div>
                <div>Gurugram/Gurgaon </div>
                <div>Noida </div>
                <div>Greater Noida</div>
                <div>Greater Noida West</div>
                <div>& More</div>


                
            </div>
:
filter === "Cities"?

            <div className="coverage-details-cities">
                <div>Delhi</div>
                <div>Noida</div>
                <div>Greater Noida</div>
                <div>Ghaziabad</div>
                <div>Gurugram</div>
                <div>Faridabad</div>
            </div>
:
filter === "Brands"?

            <div className="coverage-details-brands">

            <div>AmazonBasics</div>
            <div>Blue Star</div>
            <div>Bosch</div>
            <div>Carrier</div>
            <div>Daikin</div>
            <div>O General</div>
            <div>Godrej</div>
            <div>Haier</div>
            <div>Hitachi</div>
            <div>IFB</div>
            <div>LG</div>
            <div>Lloyd</div>
            <div>Midea</div>
            <div>Panasonic</div>
            <div>Philips</div>
            <div>Samsung</div>
            <div>Sharp</div>
            <div>Siemens</div>
            <div>Toshiba</div>
            <div>Voltas</div>
            <div>Whirlpool</div>
            <div>Mitsubishi</div>
            <div>& More</div>
                
                
            </div>

            :""}

          </div>



          <div className="cta-button">
              <a href="#book-now">Book Service Now</a>
            </div>


        </div>
      </div>
    </div>
  );
};

export default CoverageDetails;
